export { default as InputRightElement } from './input-right-element';
